import { Col, Row, Typography } from 'antd';
import React, { memo } from 'react';

import { DashedButton, VehicleSelect } from '@components';
import { L } from '@lib';

const { Text } = Typography;

interface IProps {
  showAddButton?: boolean;
  onClear?: () => void;
  onSelect?: ((value: string) => void) | undefined;
  onDeselect?: ((value: string) => void) | undefined;
  onAddClick?: React.MouseEventHandler<HTMLElement> | undefined;
}

export const VehicleAddSelect: React.FC<IProps> = memo(
  ({ showAddButton = false, onDeselect, onSelect, onAddClick, onClear }) => {
    return (
      <>
        <Text>{L('Search vehicle registration number')}</Text>
        <Row justify="space-between" align="middle">
          <Col span={11}>
            <VehicleSelect onSelect={onSelect} onDeselect={onDeselect} onClear={onClear} />
          </Col>
          <Col>
            <Text>{L('or')}</Text>
          </Col>
          <Col span={11} hidden={!showAddButton}>
            <DashedButton onClick={onAddClick} title="Add new vehicle" />
          </Col>
        </Row>
      </>
    );
  }
);
